import { Form, UniversalLink } from "@/template/components";
import { useState } from "react";
import * as S from "./style.ts";
import useCurrency from "@/lib/helpers/hooks/useCurrency.ts";
import { CheckCircle } from "@/template/icons/index.ts";
import axios from "axios";

const ContactModal = ({ onClose }: { onClose: () => void }) => {
  const currency = useCurrency();

  const [success, setSuccess] = useState(false);

  const [formValue, setFormValue] = useState<Record<string, string>>({
    name: "",
    email: "",
    company: "",
    message: "",
    type: "",
  });
  const [loading, setLoading] = useState<boolean>(false);
  const [checked, setChecked] = useState<boolean>(false);
  const [errors, setErrors] = useState<any>(formValue);
  const isUs = currency === "$";

  const sendData = async ({
    name,
    email,
    company,
    message,
    num_of_users,
    phone,
  }: Record<string, string>) => {
    setLoading(true);
    try {
      await axios
        .post("/svc/contact-us", {
          name,
          email,
          phone,
          message: `${company} + ${num_of_users} + ${message}`,
          type: "New Yay Customer",
        })
        .then(({ data }) => {
          setSuccess(data?.result);
        });
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleCheckboxChange = () => {
    setChecked(!checked);
  };

  const handleSubmit = async (data: Record<string, any>) => {
    await sendData(data);
  };

  return (
    <>
      <S.ModalWrapper>
        <S.ModalBox $isModal={true}>
          <S.CloseButton onClick={onClose}>×</S.CloseButton>
          {success ? (
            <>
              <S.ThankYouContainer>
                <S.IconWrapper>
                  <CheckCircle
                    height={60}
                    width={60}
                  />
                </S.IconWrapper>
                <S.Title>Thank you!</S.Title>
                <S.Subtitle>
                  Our sales team will be contacting you shortly.
                </S.Subtitle>
              </S.ThankYouContainer>
            </>
          ) : (
            <>
              <S.ModalHeader>
                <S.Title>Need more than 50 users? Talk to us.</S.Title>
                <S.Subtitle>
                  Our dedicated sales team can tailor a custom offer for your
                  business. Talk to us today.
                </S.Subtitle>
              </S.ModalHeader>
              <S.ModalFormContainer>
                <Form
                  value={formValue}
                  onChange={setFormValue}
                  submit={{
                    text: "Submit",
                    onSubmit: handleSubmit,
                    loading: loading,
                  }}
                  inputs={[
                    {
                      label: "Full Name",
                      name: "name",
                      error: errors.name,
                      span: 6,
                      required: true,
                    },
                    {
                      label: "Email",
                      name: "email",
                      placeholder: "name@example.com",
                      validation: {
                        regex: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                        error: "Please enter a valid email address",
                      },
                      error: errors.email,
                      span: 6,
                      required: true,
                    },
                    {
                      label: "Company",
                      name: "company",
                      error: errors.company,
                      span: 6,
                    },
                    {
                      label: "Number of users",
                      name: "num_of_users",
                      span: 6,
                      type: "select",
                      placeholder: "Select the number of users",
                      options: [
                        {
                          label: "50-100",
                          key: "50-100",
                        },
                        {
                          label: "100-200",
                          key: "100-200",
                        },
                        {
                          label: "200+",
                          key: "200+",
                        },
                      ],
                      required: true,
                    },
                    {
                      label: "Phone Number",
                      name: "phone",
                      prefix: isUs ? "" : "+44",
                      placeholder: "0207 123 4567",
                      error: errors.phone,
                      span: 12,
                    },
                    {
                      label: "Message",
                      name: "message",
                      error: errors.message,
                      placeholder:
                        "Tell us more about what you're looking for.. (special features, integrations, etc.)",
                      span: 12,
                      type: "textarea",
                      required: true,
                    },
                  ]}
                  checkbox={{
                    name: "Privacy policy",
                    label: (
                      <>
                        You agree to our friendly{" "}
                        <UniversalLink
                          styled
                          target="_blank"
                          href="/about/privacy"
                        >
                          Privacy Policy
                        </UniversalLink>
                      </>
                    ),

                    checked: checked,
                    onChange: handleCheckboxChange,
                  }}
                />
              </S.ModalFormContainer>
            </>
          )}
        </S.ModalBox>
      </S.ModalWrapper>
    </>
  );
};

export default ContactModal;
